module.exports = __webpack_public_path__ + "img/defaulteActor.fde08c29.png";